import React, {useContext} from "react";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import UiPopupAIContentFeatureGroups from "./UiPopupAIContentFeatureGroups";
import UiPopupAIContentPrompts from "./UiPopupAIContentPrompts";
import UiPopupAIContentMainPrompt from "./UiPopupAIContentMainPrompt";
import UiPopupAIContentResult from "./UiPopupAIContentResult";
import UiPopupAIContentDropdowns from "./UiPopupAIContentDropdowns";
import UiPopupAIContentToggleAllGroupsCheckbox from "./UiPopupAIContentToggleAllGroupsCheckbox";
import UiPopupAIContentFeaturesAreas from "./UiPopupAIContentFeaturesAreas";

/**
 * "AI Management" tab - the upload / render options / three chained prompts / result flow the
 * popup has always had, moved out of UiPopupAIContent when the tabs were added. The SQFT AI
 * Management tab lives in UiPopupAIContentSqftAI.
 */
const UiPopupAIContentAIManagement = () => {

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {userFile} = uiPopupContext;

  const onFileChange = (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    uiPopupDispatch({
      userFile: event.target.files[0],
      saveButtonDisabled: false,
    });
  }

  return (
    <div>
      <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">01. Upload File</div>
      <div className="flex flex--start u-mb-1">
        <label className="border border-dashed link link--blue border-primary u-p-05 rounded hover:bg-lightgray3" htmlFor="aiFileUpload">Upload File {userFile ?
          <span className={"u-pl-1 u-h-1 u-leading-1 color-active bold"}>{userFile.name}</span> : null}
        </label>
        <input type="file" id="aiFileUpload" accept="image/*" className="display-none" onChange={onFileChange}/>
      </div>
      <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">02. Select Render Options</div>
      <UiPopupAIContentDropdowns/>
      <UiPopupAIContentFeaturesAreas/>
      <div className="product-actions__title u-mb-1 u-mt-0 flex flex--center flex--between">
        <span className="flex-1 text-left bold scart-block__list-item-text-title">03. Select First Prompt</span>
        <UiPopupAIContentToggleAllGroupsCheckbox/>
      </div>
      <div className="flex flex--center flex--between u-mb-1" style={{height: "200px"}}>
        <div className="u-pr-05 u-h-full" style={{width: "220px"}}>
          <UiPopupAIContentPrompts type={"First"}/>
        </div>
        <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full">
          <UiPopupAIContentMainPrompt type={"First"}/>
        </div>
        <div className="u-pl-05 u-pr-05 u-h-full flex--1">
          <UiPopupAIContentFeatureGroups type={"First"}/>
        </div>
      </div>
      <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">04. Select Second Prompt</div>
      <div className="flex flex--center flex--between u-mb-1" style={{height: "200px"}}>
        <div className="u-pr-05 u-h-full" style={{width: "220px"}}>
          <UiPopupAIContentPrompts type={"Second"}/>
        </div>
        <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full">
          <UiPopupAIContentMainPrompt type={"Second"}/>
        </div>
        <div className="u-pl-05 u-pr-05 u-h-full flex--1">
          <UiPopupAIContentFeatureGroups type={"Second"}/>
        </div>
      </div>
      <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">05. Select Third Prompt</div>
      <div className="flex flex--center flex--between u-mb-1" style={{height: "200px"}}>
        <div className="u-pr-05 flex flex--center flex--column u-h-full" style={{width: "220px"}}>
          <UiPopupAIContentPrompts type={"Third"}/>
        </div>
        <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full">
          <UiPopupAIContentMainPrompt type={"Third"}/>
        </div>
        <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full" style={{height: "200px"}}>
          <UiPopupAIContentFeatureGroups type={"Third"}/>
        </div>
      </div>
      <div className="product-actions__title bold text-left u-mb-1 scart-block__list-item-text-title u-mt-0">06. Get Render Result</div>
      <UiPopupAIContentResult/>
    </div>
  )
};

export default UiPopupAIContentAIManagement
